import AbstractRestApi from '@/api/RestApi/AbstractRestApi'

class CompanyStripeCards extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/company-stripe-cards'
    }
}

export default new CompanyStripeCards()
